import { Footer } from './footer';
import { CategoryProducts, HelloLoggedOut } from './components';
import { CarouselsContainer, HomeRootDiv, SidePadding } from './styles';
import { CategoriesSliderSkeleton } from '@components/Skeletons';
import categories from './categoriesData';
import { useAuth } from '@hooks/useAuth';
import { AssistantButton } from './components/AssistantButton';
import { useFacebokPixelEvent } from '@hooks/useFacebookPixel';
import { useEffect } from 'react';
import { HomeNavBar } from './components/homeNavBar';
import { CategoriesCard } from './landing/HeroSection/categoriesCard';
import { ProductInteractionLocation } from 'src/validators/Events/Product';

export function HomeLoggedOut() {
  const { loading } = useAuth();

  const categorySlugs = [
    'belleza',
    'accesorios-y-dispositivos',
    'cuidado-personal',
    'vitaminas-y-suplementos',
  ];
  const { trackFBEvent } = useFacebokPixelEvent();
  useEffect(
    function trackLandingView() {
      trackFBEvent('track', 'ViewContent', {});
    },
    [trackFBEvent],
  );
  if (loading) return <></>;
  return (
    <>
      <HomeNavBar isVisible={true} />
      <HomeRootDiv>
        <SidePadding>
          <HelloLoggedOut />
        </SidePadding>
        {categories.length ? <CategoriesCard /> : <CategoriesSliderSkeleton />}
        <SidePadding>
          <CarouselsContainer>
            {categorySlugs.map((slug) => {
              return (
                <CategoryProducts
                  key={slug}
                  slug={slug}
                  productLocation={
                    ProductInteractionLocation.HomeLoggedOutCategories
                  }
                  categoryLocation={'home logged out'}
                />
              );
            })}
          </CarouselsContainer>
        </SidePadding>
      </HomeRootDiv>
      <Footer />
      <AssistantButton />
    </>
  );
}
